import { Components, Theme } from '@mui/material';

export const MuiFab: Components<Theme>['MuiFab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.text.legacySecondary}`,
      color: theme.palette.text.legacySecondary,
      '&:hover': {
        backgroundColor: 'inherit',
      },
    }),
  },
};
